<template>
  <section id="container" class="gnb_pdt">
    <div>
      <div class="title_wrap">
        <h1>파우치 상세</h1>
      </div>
    </div>

    <div class="contents_wrap">
      <div class="small_title_wrap">
        <h2>기본정보</h2>
      </div>
      <div class="cmdp_photo">
        <span>
          <img
              v-show="fileSrc !== null"
              :src="fileSrc"
          >
          <img v-show="fileSrc == null" src="@/assets/img/etners-main/aiportal_img.png">
        </span>
      </div>
      <ul class="filter_list user_photo_right">
        <li>
          <dd>
            <label>No.</label>
            <ul class="w75">
              <li>
                {{ pouchInfo.itemId }}
              </li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <label>배송 상태</label>
            <ul>
              <li>
                <span> {{ pouchInfo.statusNm }} </span>
              </li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <label>내용</label>
            <ul>
              <li>
                {{ pouchInfo.contentsScnNm }}
                <span v-if="!!pouchInfo.contentsDesc">
                  ({{pouchInfo.contentsDesc}})
                </span>
              </li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <label>등록자</label>
            <ul class="w50">
              <li>
                {{ pouchInfo.frstRgstId }} | {{ pouchInfo.frstRgstDt }}
              </li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <label>최종 메일 발송일</label>
            <ul>
              <li>
                <span> {{ pouchInfo.lastEmailSendDt === null ? '-' : pouchInfo.lastEmailSendDt }} </span>
              </li>
            </ul>
          </dd>
        </li>
      </ul>
    </div>
<div class="box_flex mgt20">
    <div class="contents_wrap">
      <div class="small_title_wrap">
        <h2>발신 정보</h2>
      </div>
      <ul class="filter_list">
        <li>
          <dd>
            <label class="w30">발신 사업장</label>
            <ul class="w70">
              <li>
                {{ pouchInfo.sendFacilityNm }}
              </li>
            </ul>
          </dd>
          <dd>
            <label class="w30">발신</label>
            <ul class="w70">
              <li>
                {{ pouchInfo.sendNm }}
              </li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <label class="w30">발신 거점</label>
            <ul class="w70">
              <li>
                {{ !!pouchInfo.sendAreaNm ? pouchInfo.sendAreaNm : '-' }}
              </li>
            </ul>
          </dd>
          <dd>
            <label class="w30">발신 부서</label>
            <ul class="w70">
              <li>
                {{ pouchInfo.sendDept }}
              </li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <label class="w30">발신 코스</label>
            <ul class="w70">
              <li>
                {{ !!pouchInfo.sendCourseNm ? pouchInfo.sendCourseNm : '-' }}
              </li>
            </ul>
          </dd>
          <dd>
            <label class="w30">이메일</label>
            <ul class="w70">
              <li>
                {{ !!pouchInfo.sendMailAddr ? pouchInfo.sendMailAddr : '-' }}
              </li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <label class="w30">건물</label>
            <ul class="w70">
              <li>
                {{ !!pouchInfo.sendBuildingNm ? pouchInfo.sendBuildingNm : '-' }}
              </li>
            </ul>
          </dd>
          <dd>
            <label class="w30">시간</label>
            <ul class="w70">
              <li>
                {{ !!pouchInfo.sendAmpmScnNm ? pouchInfo.sendAmpmScnNm : '-' }}
              </li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <label class="w30">층</label>
            <ul class="w70">
              <li>
                {{ !!pouchInfo.sendFloorNm ? pouchInfo.sendFloorNm : '-' }}
              </li>
            </ul>
          </dd>
          <dd>
            <label class="w30">비고</label>
            <ul class="w70">
              <li>
                {{ !!pouchInfo.sendContents ? pouchInfo.sendContents : '-' }}
              </li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <label class="w30">구역</label>
            <ul class="w70">
              <li>
                {{ !!pouchInfo.sendZone ? pouchInfo.sendZone : '-' }}
              </li>
            </ul>
          </dd>
        </li>
      </ul>
    </div>

    <div class="contents_wrap">
      <div class="small_title_wrap">
        <h2>수신 정보</h2>
      </div>
      <ul class="filter_list">
        <li>
          <dd>
            <label class="w30">수신 사업장</label>
            <ul class="w70">
              <li>
                {{ !!pouchInfo.receiveFacilityNm ? pouchInfo.receiveFacilityNm : '-' }}
              </li>
            </ul>
          </dd>
          <dd>
            <label class="w30">수신</label>
            <ul class="w70">
              <li>
                {{ !!pouchInfo.receiveNm ? pouchInfo.receiveNm : '-' }}
              </li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <label class="w30">수신 거점</label>
            <ul class="w70">
              <li>
                {{ !!pouchInfo.receiveAreaNm ? pouchInfo.receiveAreaNm : '-' }}
              </li>
            </ul>
          </dd>
          <dd>
            <label class="w30">수신인 부서</label>
            <ul class="w70">
              <li>
                {{ !!pouchInfo.receiveDept ? pouchInfo.receiveDept : '-' }}
              </li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <label class="w30">수신 코스</label>
            <ul class="w70">
              <li>
                {{ !!pouchInfo.receiveCourseNm ? pouchInfo.receiveCourseNm : '-' }}
              </li>
            </ul>
          </dd>
          <dd>
            <label class="w30">이메일</label>
            <ul class="w70">
              <li>
                {{ !!pouchInfo.receiMailAddr ? pouchInfo.receiMailAddr : '-' }}
              </li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <label class="w30">건물</label>
            <ul class="w70">
              <li>
                {{ !!pouchInfo.receiveBuildingNm ? pouchInfo.receiveBuildingNm : '-' }}
              </li>
            </ul>
          </dd>
          <dd>
            <label class="w30">시간</label>
            <ul class="w70">
              <li>
                {{ !!pouchInfo.receiveAmpmScnNm ? pouchInfo.receiveAmpmScnNm : '-' }}
              </li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <label class="w30">층</label>
            <ul class="w70">
              <li>
                {{ !!pouchInfo.receiveFloorNm ? pouchInfo.receiveFloorNm : '-' }}
              </li>
            </ul>
          </dd>
          <dd>
            <label class="w30">비고</label>
            <ul class="w70">
              <li>
                {{ !!pouchInfo.receiveContents ? pouchInfo.receiveContents : '-' }}
              </li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <label class="w30">구역</label>
            <ul class="w70">
              <li>
                {{ !!pouchInfo.receiveZone ? pouchInfo.receiveZone : '-' }}
              </li>
            </ul>
          </dd>
        </li>
      </ul>
    </div>
</div>
    <div class="button_area w30">
      <ul>
        <li v-show="pouchInfo.status === '01'" class="w25">
          <button class="large_btn dgray" @click="deletePouch">삭제</button>
        </li>
        <li v-show="pouchInfo.status !== '99'" class="w25">
          <button class="large_btn green" @click="updatePouch">수정</button>
        </li>

        <li v-show="pouchInfo.status === '01'" class="w25">
          <button class="large_btn orange" @click="updateStatus('N')">사업장 이동</button>
        </li>
        <li v-show="pouchInfo.status === '02'" class="w25">
          <button class="large_btn orange" @click="openReceiveInfoWindow">배송 등록</button>
        </li>
        <li v-show="pouchInfo.status === '03'" class="w25">
          <button class="large_btn orange" @click="updateStatus('N')">배송 완료</button>
        </li>
        <li v-show="pouchInfo.status === '03'" class="w25">
          <button :disabled="(['01', '02', '03', '04', '05', '06'].indexOf(pouchInfo.receiveFacility)) < 0" class="large_btn orange" @click="updateStatus('Y')">배송 완료 (메일)</button>
        </li>

        <li class="w25">
          <button class="large_btn" @click="redirectToList">목록</button>
        </li>
      </ul>
    </div>
    <get-receive-info
        ref="getReceiveInfoRef"
        :propsPouchInfo="pouchInfo"
        :save-text="'배송 등록'"
        @getReceiveInfo="getReceiveInfo"
    >
    </get-receive-info>
  </section>
</template>

<script>

import ApiConfig from "@/api/api.config";
import ApiUtil from "@/api/api.util";

import GetReceiveInfo from "@/components/pouch/GetReceiveInfo";
import EtnersParseUtil from "@/common/etners.parse.util";

export default {
  name: "PouchReceiveSave",
  components: {
    GetReceiveInfo
  },
  created () {
    const vm = this
    vm.callPouchDetail()
  },
  methods: {
    callPouchDetail () {
      const vm = this
      const param = {
        loginUserToken: vm.loginUserToken,
        pouchId: vm.$route.params.pouchId,
      }
      const jsonUrl = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/pouch/pouchDetail.json`

      // API 호출
      ApiUtil.post(jsonUrl, param).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
          this.$Progress.fail()
          return false
        }
        const resultStatus = response.data.resultStatus
        if (resultStatus.messageCode !== '2000') {
          kendo.alert(resultStatus.messageText)
          return false
        }
        const resultData = response.data.resultData
        vm.pouchInfo = resultData.pouchInfo
        if(resultData.fileInfo !== null){
          vm.fileSrc = `${ApiConfig.eklDomain}/files/2000/${resultData.fileInfo.fileId}/0?lutk=${vm.loginUserToken}`
        }
      })
    },
    openReceiveInfoWindow () {
      const vm = this
      const refs = this.$refs
      if (!vm.isSU && vm.pouchInfo.sendFacility !== vm.loginUserData.facility && vm.pouchInfo.receiveFacility !== vm.loginUserData.facility) {
        kendo.alert('소속된 사업장의 물품만 수정 가능합니다.')
        return
      }

      // vm.pouchInfo.receiveAmpmScn = vm.pouchInfo.receiveAmpmScn ?? ((new Date()).getHours() < 12 ? '01' : '02')
      // refs.getReceiveInfoRef.$refs.kendoWindowRef.kendoWidget().center().open()

      vm.updateStatus('N')
    },
    getReceiveInfo (receiveInfo) {
      const vm = this
      vm.pouchInfo = {
        ...vm.pouchInfo,
        ...receiveInfo
      }
      vm.updateStatus('N')
    },
    updatePouch () {
      const vm = this
      if (!vm.isSU && vm.pouchInfo.sendFacility !== vm.loginUserData.facility && vm.pouchInfo.receiveFacility !== vm.loginUserData.facility) {
        kendo.alert('소속된 사업장의 물품만 수정 가능합니다.')
        return
      }
      this.$router.push({
        name: "PouchUpdate",
        params: {
          pouchId : vm.pouchInfo.pouchId
        }
      })
    },
    redirectToList () {
      this.$router.push({
        name: "PouchList"
      })
    },
    deletePouch () {
      const vm = this
      if (!vm.isSU && vm.pouchInfo.sendFacility !== vm.loginUserData.facility && vm.pouchInfo.receiveFacility !== vm.loginUserData.facility) {
        kendo.alert('소속된 사업장의 물품만 수정 가능합니다.')
        return
      }
      kendo.confirm('해당 건을 삭제하시겠습니까?').done(function () {
        const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/pouch/pouchDelete.json`
        const param = {
          loginUserToken: vm.loginUserToken,
          pouchId: vm.pouchInfo.pouchId,
        }

        // API 호출
        ApiUtil.post(url, param).then(response => {
          if (response.data === undefined || response.data.resultStatus === undefined) {
            kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
            this.$Progress.fail()
            return false
          }
          const resultStatus = response.data.resultStatus
          if (resultStatus.messageCode !== '2000') {
            kendo.alert(resultStatus.messageText)
            return false
          }
          kendo.alert('삭제되었습니다.')
          vm.redirectToList()
        })
      })
    },
    updateStatus (sendMailYn) {
      const vm = this
      if (!vm.isSU && vm.pouchInfo.sendFacility !== vm.loginUserData.facility && vm.pouchInfo.receiveFacility !== vm.loginUserData.facility) {
        kendo.alert('소속된 사업장의 물품만 수정 가능합니다.')
        return
      }

      if (sendMailYn === 'Y') {
        kendo.confirm("<label style='text-align: center;'>해당 건을 메일 발송 후에 상태변경하시겠습니까?<br>발송된 메일은 취소가 불가능합니다.</label>").done(() => {
          vm.mailPouchReceive()
          vm.callUpdateStatusApi()
          vm.redirectToList() // 목록으로 리다이렉트

        }).fail(() => {
          vm.callPouchDetail()
        })

      } else {
        kendo.confirm("해당 건을 상태변경하시겠습니까?").done(() => {
          vm.callUpdateStatusApi().then(()=>{
            kendo.alert('상태 변경되었습니다.')
            vm.redirectToList() // 목록으로 리다이렉트
          }).catch(()=>{
            vm.callPouchDetail()
          })
        }).fail(() => {
        })
      }
    },
    callUpdateStatusApi () {
      const vm = this
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/pouch/pouchUpdateStatus.json`
      const params = {
        loginUserToken: vm.loginUserToken,
        pouchId: vm.pouchInfo.pouchId,
        receiveFacility: vm.pouchInfo.receiveFacility,
        receiveArea: vm.pouchInfo.receiveArea,
        receiveCourse: vm.pouchInfo.receiveCourse,
        receiveBuilding: vm.pouchInfo.receiveBuilding,
        receiveFloor: vm.pouchInfo.receiveFloor,
        receiveZone: vm.pouchInfo.receiveZone,
        receiveNm: vm.pouchInfo.receiveNm,
        receiveDept: vm.pouchInfo.receiveDept,
        receiMailAddr: vm.pouchInfo.receiMailAddr,
        receiveAmpmScn: vm.pouchInfo.receiveAmpmScn,
        receiveContents: vm.pouchInfo.receiveContents
      }

      return new Promise((resolve, reject) => {
        ApiUtil.post(url, params).then(response => {
          if (response.data === undefined || response.data.resultStatus === undefined) {
            kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
            reject()
          }
          const resultStatus = response.data.resultStatus
          if (resultStatus.messageCode !== '2000') {
            kendo.alert(resultStatus.messageText)
            reject()
          } else {
            resolve()
          }
        })
      })
    },
    mailPouchReceive () {
      const vm = this
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/pouch/sendPouchReceiveMail.json`
      const params = {
        loginUserToken: vm.loginUserToken,
        pouchIdList: [vm.pouchInfo.pouchId]
      }

      // API 호출
      ApiUtil.post(url, params).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
          return false
        }
        const resultStatus = response.data.resultStatus
        if (resultStatus.messageCode !== '2000') {
          kendo.alert(resultStatus.messageText)
          return false
        }
        kendo.alert('메일 발송 후 상태 변경되었습니다.')
      })
    },
  },
  data () {
    const loginUserData = JSON.parse(sessionStorage.getItem('loginUserData'))
    const isSU = loginUserData.authId === '9999'
    return {
      loginUserToken : sessionStorage.getItem('loginUserToken'),
      loginUserData: JSON.parse(sessionStorage.getItem('loginUserData')),
      isSU: isSU,
      fileSrc: null,
      pouchInfo: {}
    }
  }
}
</script>

<style scoped>

</style>